import { PropType, computed, defineComponent, nextTick, onMounted, ref } from "vue";
import OfferBox from "../../components/OfferBox";
import Offers from "../../components/Offers";
import Utils from "../../utils/Utils";
import OfferUtils, { OfferCode } from "../../utils/OfferUtils";
import OfferBoxDocuments from "../../components/OfferBoxDocuments";
import OfferBoxDetails from "../../components/OfferBoxDetails";
import CodeForm from "../../components/CodeForm";
import { OfferJson, OrderJson } from "../../OrderForm";

export default defineComponent({
    components: {
        OfferBox,
        OfferBoxDocuments,
        Offers,
        OfferBoxDetails,
        CodeForm,
    },

    template: `
        <div v-if="offer" class="StepOfferDetails">
            <div class="wrapper wrapper--1370">
                <h1 class="title-1">{{ title }}</h1>

                <div class="StepOfferDetails__body">
                    <div class="StepOfferDetails__offer">
                        <OfferBox
                            :offer="offer"

                            :code="code"

                            label_select="Wybieram"
                            :select_disabled="selectdisabled"

                            sticky="auto"
                            :layout_variant="true"

                            @click="$emit('offer:select', $event)"
                        >
                            <template #footer>
                                <CodeForm
                                    type="single"
                                    :code="code"

                                    @editmode="selectdisabled = $event"
                                    @applyoptions="onCodeApply"
                                />
                            </template>
                        </OfferBox>
                    </div>

                    <div class="StepOfferDetails__info">
                        <div class="contentbox contentbox--white">
                            <OfferBoxDetails :offer="offer" :codeitem="codeitem" />
                        </div>
                    </div>
                </div>

                <template v-if="!code">
                    <h2 class="title-1">Zobacz także</h2>

                    <Offers
                        v-if="offers"
                        :offers="offers"

                        :visible_groups="false"
                        :allasfeatured="true"

                        @offer:click="onOfferClick"
                    />

                    <div class="StepOfferDetails__more">
                        <button type="button" class="button button--secondary" @click="$emit('more:click')">Wszystkie Taryfy</button>
                    </div>
                </template>
            </div>
        </div>
    `,

    emits: [
        'offer:select',
        'more:click',
    ],

    props: {
        offer: { type: Object as PropType<OfferJson>, required: false },
        code: { type: Object as PropType<OfferCode> },
    },

    mounted() {
        nextTick(() => {
            Utils.scrollToEl($('.StepOfferDetails'));
        });
    },

    methods: {
        onCodeApply(options: OrderJson) {
            Utils.setStep('offers.details', options.offer);

            this.$root.options = options;
        },
    },

    setup(props, ctx) {
        const olist = ref(null as OfferJson[]);

        const selectdisabled = ref(false);

        const codeitem = computed(() => {
            return OfferUtils.getOfferCodeItem(props.code, props.offer.id);
        });

        const title = computed(() => {
            if (props.offer?.id >= 300 && props.offer?.id < 400) {
                return 'Oferta Promocyjna';
            } else if (props.offer?.id >= 500 && props.offer?.id < 799) {
                return 'Oferta Promocyjna';
            } else {
                return 'Twoja wybrana oferta';
            }
        });

        const offers = computed(() => {
            let list = olist.value;
            list = list?.filter(v => v.id != props.offer.id);

            return list;

        });

        async function reload() {
            olist.value = await OfferUtils.fetchOffers(props.offer.tariff);
        }

        async function onOfferClick(offer: OfferJson) {
            await Utils.setCart('offer', {
                offer_id: offer.id,
            });

            ctx.emit('offer:select', offer);

            Utils.setStep('offers.details', offer);
            Utils.scrollToEl($('.StepOfferDetails'));
        }

        onMounted(async () => {
            await reload();
        });

        return {
            offers,

            selectdisabled,

            codeitem,
            title,

            onOfferClick,
        }
    },
});
